// web/src/pages/PrivacyPolicy.tsx
//
// Public, unauthenticated page (see PUBLIC_ROUTES in App.tsx) — renders the
// structured content from src/content/legal.ts. Reachable from the footer
// and from the signup consent checkbox.
import { Link } from 'react-router-dom';
import { PRIVACY_POLICY } from '../content/legal';

export function PrivacyPolicy() {
  return (
    <main className="min-h-dvh bg-background text-primary p-4 md:p-8 safe-shell">
      <div className="pixel-corners bg-white p-5 sm:p-8 max-w-2xl mx-auto">
        <h1 className="font-heading text-2xl md:text-3xl text-coral mb-1">
          {PRIVACY_POLICY.title.toUpperCase()}
        </h1>
        <p className="font-body text-xs text-body-grey mb-6">
          Version {PRIVACY_POLICY.version} — effective {PRIVACY_POLICY.effectiveDate}
        </p>

        <div className="space-y-6">
          {PRIVACY_POLICY.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-heading text-sm text-coral mb-2">
                {section.heading.toUpperCase()}
              </h2>
              {section.paragraphs.map((paragraph, i) => (
                <p key={i} className="font-body text-sm text-body-grey leading-relaxed mb-2">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-8 pt-4 border-t-2 border-hairline flex gap-4">
          <Link to="/terms" className="font-heading text-xs text-coral hover:underline">
            TERMS OF SERVICE →
          </Link>
          <Link to="/" className="font-heading text-xs text-body-grey hover:underline">
            ← BACK
          </Link>
        </div>
      </div>
    </main>
  );
}

export default PrivacyPolicy;
